import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Router } from 'react-router-dom'

class SidebarMenuItem extends Component {
	constructor(props) {
		super(props);
	}

	componentWillMount() {

	}

	componentDidMount() {

	}

	render() {
		const hasSubItems = undefined !== this.props.item.items && this.props.item.items.length > 0;

		return (
			<li>
				<Link to={this.props.item.url}>{this.props.item.title}</Link>

				{
					hasSubItems ? (
						this.props.item.items.map((item, key) => (
							<ul key={key}>
								<SidebarMenuItem item={item} />
							</ul>
						))
					) : (
						''
					)
				}

			</li>
		);
	}
}

const mapStateToProps = (state) => {
	return {}
};

export default connect(mapStateToProps)(SidebarMenuItem)


// WEBPACK FOOTER //
// ./src/application/templates/sidebarMenuItem.js